<script>
 import 'whatwg-fetch';
 import 'promise-polyfill/src/polyfill';
 import { onMount } from 'svelte';
 import Map from './Map.svelte';
 export let ready;
 export let params;

 let mill, companies, center;
 let products = [];
 let freeform = "";
 let legacy_products = [];

 onMount( function() { getMillDetails() } );

 function getMillDetails() {

   fetch('/api/product-locator/mill/' + params.mill)
     .then(async function(response) {
       var data = await response.json();

       mill = data.mill;
       center = { lat: parseFloat(data.center[0]),
                  lng: parseFloat(data.center[1])
                };
       companies = [ { id: "", name: mill.company, facilities: [ data.mill ] } ];
       products = data.products;
       freeform = data.freeform;
       legacy_products = data.legacy_products;
       console.log(data);
     });
 }
</script>

{#if mill}
  <div class="left">
    <div class="mill">
      <h2>{ mill.company } ( { mill.plantid } )</h2>
      <p>
        {#if mill.company_name}
          <strong>Company:</strong> <a href="/buyers-guide/company/{mill.company_id}">{mill.company_name}</a><br/>
        {/if}
        {#if mill.city}
          <strong>City:</strong> {mill.city}, {mill.state}<br>
        {/if}
        {#if mill.contact}
          <strong>Contact: </strong>{mill.contact}<br>
          {#if mill.email}
            <strong>Email: </strong><a href="mailto:{mill.email}">{mill.email}</a><br>
          {/if}
        {/if}
        {#if mill.phone1}
          <strong>Phone: </strong>{mill.phone1}<br>
        {/if}
        {#if mill.fax}
          <strong>Fax: </strong>{mill.fax}
        {/if}
      </p>
      <div class="option_container">
        {#if products.length}
          <div class="options">
            <strong>Products</strong>
            <ul>
              {#each products as product}
                <li>{product}</li>
              {/each}
            </ul>
          </div>
        {/if}

        {#if freeform}
          <div class="options">
            <strong>Speciality/Other Products</strong>
            <p>{@html freeform}</p>
          </div>
        {/if}
      </div>

      {#if mill.legacy_products}
        {#if legacy_products.length}
          <div class="legacy_option_container">
            <div class="options">
              <strong>General Product Information</strong>
              <ul>
                {#each legacy_products as product}
                  <li>{product}</li>
                {/each}
              </ul>
            </div>
          </div>
        {/if}
      {/if}
    </div>
  </div>
  <div class="right map-outer-wrap">
    {#if ready}
      <Map companies={companies} center={center} ></Map>
    {/if}

    <hr>

    <p>
      <strong>Printable Subscriber Rosters</strong><br>
      <a target="_blank" href="/uploads/pdfs/lumber.pdf">Lumber</a><br>
      <a target="_blank" href="/uploads/pdfs/treating.pdf">Treating</a><br>
    </p>

  </div>
{/if}

<style>
  .mill {
    padding: 5px 10px;
    margin: 20px;
    margin-left: 0px;
  }

  .mill h2 {
    font-size: 1.4rem;
    margin: 0;
  }

 .left {
   width: 50%;
 }

 .right {
   width: 50%;
 }

 .options {
   font-size: 1.2rem;
   line-height: 1.5rem;
 }

 .options ul {
   list-style-position: inside;
   margin: 20px;
   margin-top: 10px;
 }

 .options ul li {
   line-height: 1.5rem;
 }

 @media (max-width: 850px) {
   .left, .right {
     width: 100%;
   }
 }
</style>
